import Vue from 'vue'

Vue.directive('focus', {
  inserted(el, {value}) {
    if (value) {
      el.focus()
    }
  }
})

Vue.directive('iframe-container', function(el) {
  let str = el.innerHTML
  str = str.replace(/<iframe/gi, '<div class="iframe-container"><iframe')
  str = str.replace(/<\/iframe>/gi, '</iframe></div>')
  el.innerHTML = str
})

Vue.directive('a-blank-target', function(el) {
  for (let a of el.getElementsByTagName('a')) {
    a.setAttribute('target', '_blank')
  }
})

Vue.directive('img-clickable', function(el) {
  for (let img of el.getElementsByTagName('img')) {
    img.setAttribute('onclick', `window.open("${img.src}", "_blank")`)
  }
})
